const SidebarAchieverIcon = ({ src, alt, size = 24 }) => (
  <img
    src={src}
    alt={alt}
    className="sidebar-achiever-icon"
    style={{
      width: `${size}px`,
      height: `${size}px`,
      minWidth: `${size}px`,
      minHeight: `${size}px`,
      objectFit: "contain",
      display: "block",
    }}
  />
);

export default SidebarAchieverIcon;
